import {BaseModelMicroService} from './base-model-micro-service';

export class ProductRef extends BaseModelMicroService {
    name: string;
    code: string;
    retailerPrice?: number;
    measurementUnit?: string;
    unitVolume: number;

}
